import * as Sentry from "@sentry/nuxt";
import { beforeSend } from './sentry'

Sentry.init({
    dsn: "https://f93100f27b09d55bf0ff39aa24cf3dce@o50847.ingest.us.sentry.io/4510505877504000",
    beforeSend,
});
